import React, { useEffect, useState } from 'react';
import { get, times, toString, size } from 'lodash';
import { func, object, array } from 'prop-types';
import { FormSelect, Row, FormInput, Text, Column } from '../../../../common';
import { genUUID } from '../../../../../utils/misc';

const Nps = ({ question, updateQuestions, npsOptions }) => {
    const options = get(question, 'options', []);

    useEffect(() => {
        updateOptions(size(options) === 0 ? 11 : size(options))
    }, [])

    const updateOptions = (sizeOptions) => {
        const newOptions = times(sizeOptions, (i) => ({ description: toString(i), idOption: genUUID(), type: 3, orden: i + 1 }));
        updateQuestions('options', newOptions);
    };

    return <Column>
        <Row>
            <Row align='center' gap={10}>
                <Text text='Valor inicial:' style={{ width: 75 }} />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        height: 34,
                        width: 50,
                        border: '1px solid #888888',
                        borderRadius: 4,
                        backgroundColor: 'white'
                    }}
                ><Text text='0' padding={5} /></div>
                <FormInput
                    onChange={({ target }) => updateQuestions('startLabelNps', get(target, 'value'))}
                    width='130px'
                    style={{ margin: 0 }}
                    maxLength={20}
                    value={get(question, 'startLabelNps', '')}
                    placeholder='Etiqueta (opcional)'
                />
            </Row>
        </Row>
        <Row>
            <Row align='center' gap={10}>
                <Text text='Valor final:' style={{ width: 75 }} />
                <FormSelect
                    options={npsOptions}
                    onChange= {({ value }) => updateOptions(get(value, 'value') > 0 ? get(value, 'value') + 1 : 11)}
                    value={size(options) > 0 ? { value: size(options) - 1, label: size(options) - 1 } : { value: 10, label: 10 }}
                    width='50px'
                    placeholder='1'
                />
                <FormInput
                    onChange={({ target }) => updateQuestions('endLabelNps', get(target, 'value'))}
                    width='130px'
                    style={{ margin: 0 }}
                      maxLength={20}
                    value={get(question, 'endLabelNps', '')}
                    placeholder='Etiqueta (opcional)'
                />
            </Row>
        </Row>
    </Column>;
};

Nps.propTypes = {
    question: object,
    npsOptions: array,
    updateQuestions: func
};

export default Nps;
